import {
  FETCH_SCAN_AVATAR,
  FETCH_SCAN_AVATAR_SUCCESS,
  FETCH_SCAN_AVATAR_FAILURE,
  RESET_SCAN_AVATAR,
} from '../actions/types'
import Immutable from 'immutable'

const reducers = {
  [FETCH_SCAN_AVATAR]: (state) => {
    return state.set('loading', true).set('error', null)
  },
  [FETCH_SCAN_AVATAR_SUCCESS]: (state, action) => {
    return state
      .set('scanAvatarData', Immutable.fromJS(action.payload.data))
      .set('loading', false)
      .set('error', null)
  },
  [FETCH_SCAN_AVATAR_FAILURE]: (state, action) => {
    return state
      .set('loading', false)
      .set(
        'error',
        action.payload.response
          ? action.payload.response.status
          : 'Network error'
      )
  },
  [RESET_SCAN_AVATAR]: (state) => {
    return state
      .set('scanAvatarData', null)
      .set('loading', false)
      .set('error', null)
  },
}

const defaultState = Immutable.Map({
  loading: false,
  error: null,
  scanAvatarData: null,
})

export default function (state = defaultState, action) {
  if (action && typeof reducers[action.type] === 'function') {
    return reducers[action.type](state, action)
  }
  return state
}
